import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./basic.module.css";
import FormFields from "@components/Form";
import SaveButton from "@components/SaveButton";
import IconButton from "common/IconButton";
import CheckBox from "common/CheckBox";
import { BurgerMenuContext } from "context/sidebar";
import { postData, updateData, SearchOptions } from "utils/queries";
import IncludeElements from "../IncludeElements";
import Badge from "common/Badge";
import InputNumber from "common/InputNumber";
import { useNavigate } from "react-router-dom";
import Toast from "utils";
const Basic = ({ package_id, data }) => {
  const [packageDetails, setPackageDetails] = useState({
    name: "",
    tagline: "",
    no_of_guests: "",
    image_url: "",
    // addTicket: 0,
    // forChildren: "",
    // extraChild: 0,
    pricing: 0,
    elements: [],
    has_sum_total: true,
    has_custom_price: false,
  });
  useEffect(() => {
    if (package_id && data?.id) {
      setPackageDetails({ 
        ...data,
        installment_plans: (data?.installment_plans || []).map(plan => 
          typeof plan === 'string' ? { label: plan.replace("installment_", "") + " Months", value: plan } : plan
        ),
        event_name: data.event_id && data.event_name ? {
          label: data.event_name,
          value: data.event_id,
          installment_plans: data.installment_plans || []
        } : data.event_name,
      });
    }
  }, [package_id, data?.id, data]);

  const burgerContext = useContext(BurgerMenuContext);
  const sidebarRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        burgerContext.setShowSideBar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [burgerContext]);

  var updateSidebar = (packgeDetails) => {
    burgerContext.updateComp({
      comp: (
        <div ref={sidebarRef}>
          <IncludeElements
            setPackageDetails={setPackageDetails}
            elements={packageDetails?.elements}
            packageDetails={packgeDetails}
            syncState={syncState}
          />
        </div>
      ),
      right: true,
      isOpen: true,
    });

    burgerContext.setShowSideBar(true);
  };

  var syncState = (packgeDetails) => {
    updateSidebar(packgeDetails);
    setPackageDetails(packgeDetails);
  };

  const handleChange = (label) => (e) => {
    let value = e.target ? e.target.value : e;
  
    if (e?.target?.type === "checkbox") {
      value = e.target.checked;
      const name = e?.target?.name;
  
      setPackageDetails((prevDetails) => {
        let updatedDetails = {
          ...prevDetails,
          [label]: value,
        };
  
        if (name === "has_sum_total" && value) {
          updatedDetails.has_custom_price = false;
          updatedDetails.custom_price_value = 0; // Reset custom price
        } else if (name === "has_custom_price" && value) {
          updatedDetails.has_sum_total = false;
        }
  
        return updatedDetails;
      });
  
      return;
    }
  
    setPackageDetails((prevDetails) => ({
      ...prevDetails,
      [label]: value,
    }));
  };
  

  // Function to handle quantity change for variants
  const handleQuantityChange = (ticketId, variantId, newQuantity) => {
    setPackageDetails((prevDetails) => {
      const updatedElements = prevDetails.elements.map((ticket) => {
        if (ticket.ticket_id === ticketId) {
          const updatedVariants = ticket.variants.map((variant) => {
            if (variant.variant_id === variantId) {
              return {
                ...variant,
                quantity: newQuantity >= 1 ? newQuantity : 1,
              };
            }
            return variant;
          });
          return {
            ...ticket,
            variants: updatedVariants,
          };
        }
        return ticket;
      });
      return {
        ...prevDetails,
        elements: updatedElements,
      };
    });
  };

  const fetchOptions = async (search = "") => {
    try {
      let optionsResult;
      
      if (!search || search.trim() === "") {
        // Load all upcoming events when no search term
        optionsResult = await SearchOptions(`event/events?eventType=upcoming&limit=100&offset=0&currentDate=${new Date().toISOString()}`);
        return optionsResult?.data?.data?.rows?.map((e) => ({
          value: e?.id,
          label: e?.event_name,
          starts: e?.starts,
          ends: e?.ends,
          booking_fee_percentage: e?.booking_fee_percentage,
          installments_enabled: e?.installments_enabled,
          installment_plans: e?.installment_plans,
          installment_min_amount: e?.installment_min_amount,
          installment_cutoff_days: e?.installment_cutoff_days,
        })) || [];
      } else {
        // Use search endpoint when user types
        optionsResult = await SearchOptions(`ticket/search?key=${search}`);
        return optionsResult?.data?.data
          ?.filter((e) =>
            e?.event_name?.toLowerCase().includes(search.toLowerCase())
          )
          ?.map((e) => ({
            value: e?.id,
            label: e?.event_name,
            starts: e?.starts,
            ends: e?.ends,
            booking_fee_percentage: e?.booking_fee_percentage,
            installments_enabled: e?.installments_enabled,
            installment_plans: e?.installment_plans,
            installment_min_amount: e?.installment_min_amount,
            installment_cutoff_days: e?.installment_cutoff_days,
          })) || [];
      }
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };

  const FirstFormFields = [
    {
      label: "Event Name",
      id: "event_name",
      placeholder: "Event Name",
      isDisabled: package_id ? true : false,
      loadOptions: fetchOptions,
      isSearchable: true,
      type: "select_search",
      value: packageDetails?.event_name,
      required: true,
      loading: true,
      onChange: handleChange("event_name"),
    },
    {
      label: "Package Name",
      id: "name",
      placeholder: "Enter Package Name",
      type: "text",
      // disabled: package_id ? true : false,
      value: packageDetails?.name,
      formGroupStyleOverride: { width: "100%" },
      required: true,
      onChange: handleChange("name"),
    },
    {
      label: "Tag Line",
      id: "tagline",
      placeholder: "Tag Line",
      type: "text",
      maxLength: 150,
      value: packageDetails?.tagline,
      formGroupStyleOverride: { width: "100%" },

      required: true,
      onChange: handleChange("tagline"),
    },
    {
      label: "No Of Guests",
      id: "no_of_guests",
      placeholder: "Specify the number of guests",
      min: 0,
      max: 1000,
      type: "number",
      value: packageDetails?.no_of_guests,
      required: true,
      onChange: handleChange("no_of_guests"),
    },
    {
      parentLabel: "Ticket Image",
      label:
        "Events with images are noticed by more customers, and usually sell more tickets.",
      id: "image_url",
      type: "image",
      value: packageDetails?.image_url,

      onChange: handleChange("image_url"),
    },
    // {
    //   label: "Custom Price",
    //   id: "no_of_guests",
    //   placeholder: "Specify the number of guest",
    //   min: 0,
    //   max: 1000,
    //   type: "number",
    //   value: packageDetails?.no_of_guests,
    //   required: true,
    //   onChange: handleChange("no_of_guests"),
    // },
  ];

  const SecondFormFields = [
    {
      label: "Custom Price",
      id: "custom_price_value",
      placeholder: "Enter the custom price",
      min: 0,
      max: 1000,
      step: "0.01", // Add this to allow two decimal places
      type: "number",
      value: packageDetails?.custom_price_value,
      required: true,
      pounds: true,
      onChange: handleChange("custom_price_value"),
    },
    {
      label: "Enable Installments",
      parentLabel: "Payment Plans",
      id: "installments_eligible",
      name: "installments_eligible",
      type: "checkbox",
      checked: packageDetails?.installments_eligible ?? false,
      onChange: handleChange("installments_eligible", (e) => e?.target?.checked),
    },
    ...(packageDetails?.installments_eligible ? [
      {
        label: "Installment Plans",
        id: "installment_plans",
        placeholder: "Select plans...",
        type: "select",
        isMulti: true,
        value: packageDetails?.installment_plans || [],
        options: (packageDetails?.event_name?.installment_plans || []).map(plan => ({
          label: plan.replace("installment_", "") + " Months",
          value: plan
        })),
        onChange: handleChange("installment_plans"),
      },
      {
        label: "Minimum Amount for Installments",
        id: "installment_min_amount",
        placeholder: "e.g. 20",
        type: "number",
        min: "0",
        step: "0.01",
        value: packageDetails?.installment_min_amount,
        required: true,
        onChange: handleChange("installment_min_amount"),
      },
    ] : []),
  ];

  const saveTicket = () => {
    console.log("saveTicket");
    
    navigate("/package");
  };

  const firstButtonArgs = {
    label: "Save",
    id: "save",
    type: "submit",
    buttonOverrideInlineStyle: {
      // background: "#E7E7EE",
      marginRight: "16px",
    },
    // onclick: handleAddTicket,
  };
  const secondButtonArgs = {
    label: "Discard",
    id: "cancel",
    type: "button",
    // buttonOverrideInlineStyle: { background: "white" },
    onClick: () => navigate("/package"), // Fix casing
  };

  const handleSavePackage = async (e) => {
    try {
      e?.preventDefault();

      if (!packageDetails?.elements || packageDetails?.elements.length === 0) {
        Toast().Error(
          "Include Elements are mandatory. Please add at least one element."
        );
        return;
      }

      if (!packageDetails?.has_custom_price && !packageDetails?.has_sum_total) {
        Toast().Error("Either 'Sum Total' or 'Custom Price' must be selected.");
        return;
      }

      if (
        packageDetails?.has_custom_price &&
        !packageDetails?.custom_price_value
      ) {
        Toast().Error(
          "Custom Price is mandatory if 'Custom Price' is selected."
        );
        return;
      }

      // Filter elements to include only those with at least one checked variant
      const filteredElements = packageDetails?.elements
        ?.map((ticket) => ({
          ...ticket,
          variants: ticket?.variants?.filter((e) => e?.checked),
        }))
        .filter((ticket) => ticket.variants.length > 0); // Ensure only tickets with checked variants are included

      if (filteredElements.length === 0) {
        Toast().Error("At least one variant must be checked.");
        return;
      }

      const payload = {
        ...packageDetails,
        event_id: packageDetails?.event_name?.value || null,
        elements: filteredElements,
        installments_eligible: packageDetails?.installments_eligible || false,
        installment_plans: packageDetails?.installments_eligible 
          ? (Array.isArray(packageDetails?.installment_plans) 
              ? packageDetails.installment_plans.map(p => p.value || p)
              : [])
          : [],
        installment_min_amount: packageDetails?.installments_eligible 
          ? parseFloat(packageDetails?.installment_min_amount || 0)
          : 0,
      };
      delete payload.event_name;

      if (package_id) {
        console.log("packageDetails", filteredElements);

        const result = await updateData(`package/packages/${package_id}`, payload);
        if(result?.status===200){
          navigate("/package")
        }else if (result?.status === 400) {
          window.scrollTo({ 
            top: document.documentElement.scrollHeight / 4, 
            behavior: "smooth" 
          });
        }
      } else {
        const result = await postData("package/packages", payload);
        // navigate("/package");
        // return result;
        if(result?.status===201){
          navigate("/package")
        }else if (result?.status === 400) {
          window.scrollTo({ 
            top: document.documentElement.scrollHeight / 4, 
            behavior: "smooth" 
          });
        }
      }
      
      // navigate("/package");
    } catch (error) {
      // Handle error
      console.error("Error saving package:", error);
      Toast().Error("An error occurred while saving the package.");
    }
  };

  return (
    <>
      <div className={styles.container}>
        <form onSubmit={handleSavePackage}>
          <div
            style={{
              width: "100%",
              border: "1px solid #dcdce5",
              padding: "20px",
              borderRadius: "4px",
            }}
          >
            <div className={styles.packagelabels}> Package Detail's </div>
            <FormFields Fields={FirstFormFields} />
          </div>

          <div className={styles.includeElements}>
            <div className={styles.includelabels}>
              {" "}
              Include Elements <span className={styles.required}>*</span>
            </div>
            <div className={styles.packageSubLabels}>
              {" "}
              Include Elements are the fundamentals of the package and not edit
              bby customer.{" "}
            </div>

            {packageDetails?.elements?.flatMap((ticket) => {
              const checkedVariants = ticket?.variants?.filter(
                (variant) => variant?.checked
              );

              if (checkedVariants?.length === 0) return [];

              return checkedVariants.map((variant) => (
                <div
                  className={styles.includedItems}
                  key={`${ticket.ticket_id}-${variant.variant_id}`}
                >
                  <div className={styles.includes}>
                    <img
                      className={styles?.ticket_image}
                      src={ticket?.image_url}
                      alt={ticket?.ticket_name}
                    />
                    <div className={styles.info}>
                      <div className={styles.label}>{ticket?.ticket_name}</div>
                      <div className={styles.venue}>
                        <Badge
                          label={variant?.variant_name || ticket?.ticket_name}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={styles.priceAndAction}>
                    <div className={styles.price}>
                      {/* <p>
                      £{variant?.customer_pays || ticket?.customer_pays || 0}</p> */}
                      <p className={styles.price}>
                        £
                        {(
                          (variant?.customer_pays ||
                            ticket?.customer_pays ||
                            0) * (variant?.quantity || 1)
                        ).toFixed(2)}
                      </p>
                    </div>
                    <div className={styles.quantityBox}>
                      <button
                        type="button"
                        className={styles.quantityButton}
                        onClick={() =>
                          handleQuantityChange(
                            ticket.ticket_id,
                            variant.variant_id,
                            (variant.quantity || 1) - 1
                          )
                        }
                      >
                        -
                      </button>
                      <span className={styles.quantityValue}>
                        {variant.quantity || 1}
                      </span>
                      <button
                        type="button"
                        className={styles.quantityButton}
                        onClick={() =>
                          handleQuantityChange(
                            ticket.ticket_id,
                            variant.variant_id,
                            (variant.quantity || 1) + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              ));
            })}

            <IconButton
              buttonLabel={"Set Included elements"}
              icon={"element"}
              // type="button"
              buttonFunction={(e) => {
                e.preventDefault();
                updateSidebar(packageDetails);
              }}
            />
          </div>

          <div className={styles.pricing}>
            <div>
              <div className={styles.includelabels}> Pricing </div>
              <div className={styles.packageSubLabels}>
                Include Elements are the fundamentals of the package and not
                edit bby customers.
              </div>
            </div>

            <div className={styles.PricingCheckBox}>
              <div>
                <div className={styles.label}>Sum Total</div>
                <div className={styles.subLabel}>
                  A dynamic price generated from include elements and associated
                  items.
                </div>
              </div>
              <CheckBox
                label={null}
                checked={packageDetails?.has_sum_total}
                name="has_sum_total"
                formGroupStyleOverride={{ width: "fit-content" }}
                onClick={handleChange("has_sum_total")}
              />
            </div>

            <div className={styles.customPriceCheckBox}>
              <div>
                <div className={styles.label}>Custom Price</div>
                <div className={styles.subLabel}>
                  Hide and override included elements prices and fee with unique
                  price and company wide booking fee.
                </div>
              </div>
              <CheckBox
                label={null}
                type="checkbox"
                name="has_custom_price"
                checked={packageDetails?.has_custom_price}
                formGroupStyleOverride={{ width: "fit-content" }}
                onChange={handleChange("has_custom_price")}
              />
            </div>

            {packageDetails?.has_custom_price && (
              <>
                {/* <InputNumber
                  label={"Custom Price"}
                  type="number"
                  min={0}
                  maxLength={5}
                  pounds={true}
                  pricing={"price"}
                  required={true}
                  onChange={handleChange("custom_price_value")}
                /> */}
                <FormFields Fields={SecondFormFields} />
              </>
            )}
          </div>
          <SaveButton
            firstButtonArgs={firstButtonArgs}
            secondButtonArgs={secondButtonArgs}
          />
        </form>
      </div>
    </>
  );
};

export default Basic;
